import uuid from 'uuid'
import EntityTypes from '@slite/editor/lib/types/EntityTypes'
import processSliteUrl from '@slite/editor/lib/plugins/utils/processSliteUrl'

export default function makeNoteLinkExtractor({
  showNote,
  showNoteByToken,
  appDomain,
  organizationDomain,
}) {
  return async function noteLinkExtractor(editor, { url, range }) {
    if (!url) {
      return null
    }

    const { noteId, publicShareToken, blockId } = processSliteUrl(url, {
      appDomain,
      organizationDomain,
    })
    if (!noteId && !publicShareToken) {
      return null // let other extractors do stuff
    }

    const entityId = uuid()
    const data = {
      entityId,
      blockId,
      noteId,
    }
    try {
      editor.insertInlineAtRange(range.normalize(editor.value.document), {
        type: EntityTypes.NOTELINK,
        data,
        nodes: [
          {
            object: 'text',
            text: 'Loading...',
            marks: editor.value.marks,
          },
        ],
      })

      const callback = async () => {
        let noteTitle = null
        const additionalData = {}
        try {
          if (noteId) {
            const { result } = await showNote({ noteId })
            noteTitle = result.data.showNote.title || 'Untitled'
          } else if (publicShareToken) {
            const { result } = await showNoteByToken({
              token: publicShareToken,
            })
            noteTitle = result.data.showNoteByToken.title
            additionalData.noteId = result.data.showNoteByToken.id
          }
        } catch (e) {
          if (e.error && e.error.errors[0].status === 404) {
            additionalData.notFound = true
          }

          noteTitle = 'Doc'
        }
        const node = editor.value.document.findDescendant(
          child =>
            child.object === 'inline' &&
            child.getIn(['data', 'entityId']) === entityId
        )

        if (!node) {
          // Node can be deleted while we fetch, lets not touch anything in that case
          return null
        }

        const placeholderLength = node.getTexts().first().text.length
        const textKey = node.getFirstText().key

        editor.withoutNormalizing(() => {
          editor
            .setNodeByKey(node.key, {
              data: node.data.merge(additionalData),
            })
            .insertTextByKey(textKey, placeholderLength, noteTitle)
            .removeTextByKey(textKey, 0, placeholderLength)
        })
      }

      editor.command('addOnSyncDoneCallback', callback)
      return true
    } catch (error) {
      return null
    }
  }
}
